import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { PRODUCTS, bumpCatalogVersion, type Product } from '../data/products';

const MASTER_CATALOG_ID = 'master_catalog_v2';

const rebindCatalog = (items: Product[]) => {
  PRODUCTS.splice(0, PRODUCTS.length, ...items);
  bumpCatalogVersion();
};

export const fetchMasterCatalog = async (): Promise<Product[] | null> => {
  // A failed Firestore read (e.g. no backend configured in a bare dev run)
  // returns null via the catch below, so boot proceeds on the static seed in
  // `src/data/products.ts`.
  try {
    const configRef = doc(db, 'system_config', MASTER_CATALOG_ID);
    const snap = await getDoc(configRef);
    if (snap.exists()) {
      const dbItems = snap.data().items as Product[];
      rebindCatalog(dbItems);
      return dbItems;
    }
    // Zero-day seeding: push the static payload so future reads hit Firestore.
    await setDoc(configRef, { items: PRODUCTS });
    return null;
  } catch (error) {
    console.error('Failed to fetch master catalog from Firestore', error);
    return null;
  }
};

export const deployMasterCatalog = async (newCatalog: Product[]): Promise<void> => {
  const configRef = doc(db, 'system_config', MASTER_CATALOG_ID);
  await setDoc(configRef, { items: newCatalog });
  rebindCatalog(newCatalog);
};
